/**
 * 通知模块
 * 接口文档地址:http://gitlab.10niu.cn/repository/editor?id=80&itf=2640
 *
 * 通知公告v2.2.1
 * 接口文档地址:http://rap2.10niu.cn/organization/repository/editor?id=108&itf=3789
 */
import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

const notice = {
	// 新版后台_通知v1_获取模板分类列表all
	noticeType(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v1/template/type/list/all`,
			params
		});
	},
	// 新版后台_通知v1_添加通知模板
	addNotice(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/notice/v1/template/add/one`,
			data: qs.stringify(data)
		});
	},
	// 新版后台_通知v1_获取模板列表分页
	noticeList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v1/template/list/page`,
			params
		});
	},
	// 新版后台_通知v1_物理删除通知模板
	delNotice(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/notice/v1/template/del/one`,
			data: qs.stringify(data)
		});
	},
	// 新版后台_通知v1_获取模板详情
	find(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v1/template/find`,
			params
		});
	},
	// 新版后台_通知v1_编辑通知模板
	editNotice(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/notice/v1/template/edit/one`,
			data: qs.stringify(data)
		});
	},
	// 通知v2_2_1_后台_获取学校下的职工列表
	getStaffListBySchool(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v2/admin/get_staff_list_by_school`,
			params
		});
	},
	// 通知v2_2_1_后台_组织架构
	getOrgStruct(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v2/admin/org_struct`,
			params
		});
	},
	// 通知v2_2_1_后台_获取班级下老师
	getClassTeacher(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v2/admin/get_class_teacher`,
			params
		});
	},
	// 通知v2_2_1_后台_获取班级下学生
	getClassStudent(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v2/admin/get_class_student`,
			params
		});
	},
	// 通知v2_2_1_后台_发布通知
	releasingNotices(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/notice/v2/admin/add_notice`,
			data: qs.stringify(data)
		});
	},
	// 通知v2_2_1_后台_导出通知
	getNoticeAllExport(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/notice/v2/admin/export_all_notice`,
			params
		});
	}
};
export default notice;
